export const CHATS = {
    TITLE: 'Gestión por Chats',
    DETAIL_TITLE: 'Detalle de Visita',
    GROUP_NAME_TITLE: 'Nombre del Grupo',
    USER_NAME_TITLE: 'Visitante',
    SQUAD_NAME_TITLE: 'Célula',
    DELETED_DOC_MSG: 'Documento eliminado exitosamente',
    DELETED_DOC_FROM_LOAN_ATTACHMENT_CHAT_MSG: (authorName, fileName) =>
        `${authorName} ha eliminado del Tab de Adjuntos de la Solicitud el documento con nombre: ${fileName}`,
    DELETED_DOC_FROM_LOAN_ATTACHMENT_MSG: (by, date) =>
        `Eliminado del Tab de Adjuntos de la Solicitud por ${by} el ${date}`,
    DURATION_TITLE: 'Duración',
    TYPE_TITLE: 'Tipo',
    DATE_TITLE: 'Fecha',
    CREATED_AT: 'Realizada el:',
    COMMENTS_TITLE: 'Comentarios',
    LOCATION_TITLE: 'Geolocalización',
    FILTER_SELECT: 'Seleccione un',
    FILTER_BY_GROUP: 'Grupo',
    FILTER_BY_TYPE: 'Tipo',
    FILTER_BY_USER: 'Visitante',
    FILTER_BY_SUPERVISOR: 'Supervisor',
    FILTER_BY_DATE_FROM: 'Fecha Desde',
    FILTER_BY_DATE_TO: 'Fecha Hasta',
    FILTER_RESET_BUTTON: 'Limpiar',
    FILTER_DATES_ERROR: 'Rango de fechas incorrectas',
    NO_SELECTED_LOAN_GROUP: 'Por favor selecciona una opción del menú',
    REASON: 'Razón',
    PIN: 'AGREGAR PIN',
    UNPIN: 'QUITAR PIN',
    UPLOAD_FILES_LABEL: 'Selecciona el tipo de documento que vas a adjuntar.',
    UPLOAD_DOCUMENT_TYPE_LABEL: 'Tipo de documento',
    ASSIGN_DOC: 'Asignar Archivo a Solicitud',
    UPLOAD_LABEL:
        'Arrastra a esta zona el PDF o la imagen JPG o PNG a subir o selecciona el archivo. Peso máximo 10Mb.',
    UPLOAD_ERROR: 'Ocurrió un error al subir el archivo',
};

export const LOAN_FILTER = {
    GROUPS: 'Grupo',
    SUPERVISOR: 'Supervisor',
    ADVISOR: 'Asesor',
};
